/* eslint-disable prefer-destructuring */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';
// =================Dependancies==================
import Button from '@mui/material/Button';
import {
  Typography, Modal, Box, Fade, Backdrop,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

// =================Actions====================
import { setDateHighlight, setDownloadButton, setOpenModal } from '../../../../actions/metadata';

//  =================JSX Style==================
const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  border: '1px solid grey',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
};

const styleItalic = {
  fontWeight: 'bold',
  fontStyle: 'italic',
  marginTop: '3em',
};

// const stylePadding = {
//   paddingBottom: '1em',
// };

function Modaldownload() {
  // ==================HOOK=========================
  const dispatch = useDispatch();
  const openModal = useSelector((state) => state.metadata.data.modal.openModal);
  const dateSelectedArray = useSelector((state) => state.metadata.data.calendar.dateSelectedArray);
  const calendarData = useSelector((state) => state.metadata.data.calendar.calendarData);
  const downloadButton = useSelector((state) => state.metadata.data.calendar.downloadButton);
  // ================Handler=======================

  const handleOpenModal = () => {
    dispatch(setOpenModal(true));
  };

  const handleCloseModal = () => {
    dispatch(setOpenModal(false));
  };

  // =================Function====================

  // function to dowload reslut with user selection of date
  function downloadWithDate(filename, format) {
    let clickDate = '';
    let scriptText = '';
    let link = '';

    while (dateSelectedArray.length > 0) {
      if (format === 'sh') {
        for (let i = 0; i < dateSelectedArray.length; i += 1) {
          clickDate = dateSelectedArray[0];
          for (let j = 0; j < calendarData.length; j += 1) {
            const myDate = calendarData[j].reference_date.substring(0, 10);
            if (clickDate === myDate) {
              if (calendarData[j].data_center.data_center_structure.directory_naming !== '') {
                link = `${calendarData[j].data_center.protocol}://${calendarData[j].data_center.hostname}/${calendarData[j].data_center.data_center_structure.directory_naming}/${calendarData[j].relative_path}/${calendarData[j].name}`;
              }
              else {
                link = `${calendarData[j].data_center.protocol}://${calendarData[j].data_center.hostname}/${calendarData[j].relative_path}/${calendarData[j].name}`;
              }
              scriptText = `${scriptText}wget ${link}\n`;
            }
          }
          dateSelectedArray.shift();
        }
      }
      else if (format === 'txt') {
        for (let i = 0; i < dateSelectedArray.length; i += 1) {
          clickDate = dateSelectedArray[0];
          for (let j = 0; j < calendarData.length; j += 1) {
            const myDate = calendarData[j].reference_date.substring(0, 10);
            if (clickDate === myDate) {
              if (calendarData[j].data_center.data_center_structure.directory_naming !== '') {
                link = `${calendarData[j].data_center.protocol}://${calendarData[j].data_center.hostname}/${calendarData[j].data_center.data_center_structure.directory_naming}/${calendarData[j].relative_path}/${calendarData[j].name}`;
              }
              else {
                link = `${calendarData[j].data_center.protocol}://${calendarData[j].data_center.hostname}/${calendarData[j].relative_path}/${calendarData[j].name}`;
              }
              scriptText = `${scriptText + link}\r\n`;
            }
          }
          dateSelectedArray.shift();
        }
      }
      dispatch(setOpenModal(false));
    }

    const blob = new Blob([scriptText], { type: 'text/plain' });
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename);
    }
    else if (openModal) {
      const elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob);
      elem.download = filename;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
    dispatch(setDateHighlight([]));
    [...document.getElementsByClassName('ch-container')].map((n) => n && n.remove());
    dispatch(setDownloadButton(false));
  }

  function download() {
    let clickDate = '';
    let link = '';
    let url = '';
    const files = [];

    for (let i = 0; i <= dateSelectedArray.length; i += 1) {
      clickDate = dateSelectedArray[i];
      for (let j = 0; j < calendarData.length; j += 1) {
        const myDate = calendarData[j].reference_date.substring(0, 10);
        if (clickDate === myDate) {
          if (calendarData[j].data_center.data_center_structure.directory_naming !== '') {
            link = `${calendarData[j].data_center.protocol}://${calendarData[j].data_center.hostname}/${calendarData[j].data_center.data_center_structure.directory_naming}/${calendarData[j].relative_path}/${calendarData[j].name}`;
          }
          else {
            link = `${calendarData[j].data_center.protocol}://${calendarData[j].data_center.hostname}/${calendarData[j].relative_path}/${calendarData[j].name}`;
          }
          url = `${url + link}\r\n`;
          files.push(link);
        }
      }
    }

    files.forEach((file) => {
      if (openModal) {
        window.open(file);
      }
    });
    dispatch(setDateHighlight([]));
    [...document.getElementsByClassName('ch-container')].map((n) => n && n.remove());
    dispatch(setDownloadButton(false));
    dispatch(setOpenModal(false));
  }

  return (
    <>
      {(downloadButton === true) && <Button onClick={handleOpenModal} className="data__download--button">Download</Button>}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 600,
          },
        }}
      >
        <Fade in={openModal}>
          <Box sx={styleModal}>
            <Typography id="modal-modal-title" variant="h4" component="h2">
              Download
            </Typography>
            <Box>
              {/* <p style={styleItalic}>
                Direct file download was previously disabled due to browser
                policy change. Downloading from ftp link is no longer supported.
              </p> */}
              {/* <p style={stylePadding}>
                We are currently in active research to find and implement a solution
              </p> */}
              <p style={styleItalic}>
                You can download the files by clicking on the  following link.
                Note that you need to ensure that your browser allows the opening of several popups
                (see this <a href="https://support.mozilla.org/en-US/kb/pop-blocker-settings-exceptions-troubleshooting">link</a> for
                firefox, and this <a href="https://support.google.com/chrome/answer/95472?hl=en&co=GENIE.Platform%3DDesktop#zippy=%2Callow-pop-ups-and-redirects-from-a-site">link</a> for chrome).
              </p>

              <ol className="modal--list">
                <li>Direct Download: <button className="download--button" type="button" onClick={() => download()}>Download</button></li>
              </ol>

              <p> The following alternatives can still be used :</p>
              <ol className="modal--list">
                <li> The python command line client: <a className="download--link" href="https://gitlab.com/gpseurope/pyglass/-/releases" target="_blank" rel="noreferrer">Click here (Documentation included)</a></li>
                <li> A script to download the files with wget: <button className="download--button" type="button" onClick={() => downloadWithDate('eposwget.sh', 'sh')}>Click here</button></li>
                <li> A list of the file URL to download the file with any software: <button className="download--button" type="button" onClick={() => downloadWithDate('eposfilelist.txt', 'txt')}>Click here</button></li>
              </ol>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default Modaldownload;
